<div class="container-fluid">
  <app-auction-report-lot-list #auctionReportLotList></app-auction-report-lot-list>
</div>